module.exports = __webpack_public_path__ + "img/cry.30958162.gif";